import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

import { RECAPTCHA_KEY } from 'app/config';

import CartaoCredito from 'models/cartao-credito';
import { CheckoutConfig } from 'models/checkout';

@Component({
  selector: 'cartoes-credito',
  templateUrl: './cartoes-credito.component.html',
  styleUrls: ['./cartoes-credito.component.scss'],
})
export class CartoesCreditoComponent implements OnInit {

  env = environment;

  public cvvMask = [/\d/, /\d/, /\d/];
  public cartaoMask = [
    /\d/, /\d/, /\d/, /\d/, ' ',
    /\d/, /\d/, /\d/, /\d/, ' ',
    /\d/, /\d/, /\d/, /\d/, ' ',
    /\d/, /\d/, /\d/, /\d/,
  ];

  public configuracaoSelecionada: CheckoutConfig = new CheckoutConfig({});
  public validarCartaoTimeout;
  public config = [];
  public matrixParcelas = [];
  public captchaStatus = false;
  public quantidadeMaxCartoes = 0;
  public recaptchaKey = RECAPTCHA_KEY;
  public qtdCartoes: any;
  public qtdCartoesSelected: any;
  public qtdOpcoes: any;

  public meses: string[] = [];
  public anos: string[] = [];

  @Output() aoSucesso: EventEmitter<any> = new EventEmitter();
  @Input() valorTotal = 0;
  @Input() cartoes: CartaoCredito[];
  @Input() configuracoes: Observable<CheckoutConfig[]>;

  ngOnInit() {

    this.configuracoes.subscribe((response) => {
      this.qtdOpcoes = Array(response[0].qtdCartoes).fill(null);
      this.cartoes = this.gerarCartoes(this.valorTotal);
      this.gerarParcelas(response[0].qtdParcelas);
      this.qtdCartoesSelected = 0;
      this.onChangeQtdCartaoSelected(0);
    });

    this.geraMesses();
    this.geraAnos();

  }

  geraMesses() {
    // init meses vencimento
    for (let i = 1; i <= 12; i++) {
      let mes = i + '';
      if (i < 10) {
        mes = '0' + mes;
      }
      this.meses.push(mes);
    }
  }

  geraAnos() {
    // init anos vencimento
    const anoAtual = (new Date()).getFullYear();
    for (let i = 0; i < 15; i++) {
      this.anos.push((anoAtual + i) + '');
    }
  }

  gerarCartoes(valor) {
    return this.qtdOpcoes.map(q => {
      const novoCartao = new CartaoCredito();
      novoCartao.valor = valor;
      return novoCartao;
    });
  }

  onChangeValor(values) {
    if (values <= this.valorTotal) {
      this.cartoes.map((cartoes, index) => {
        if (index === 0) {
          cartoes.valor = values;
        } else {
          cartoes.valor = this.valorTotal - values;
        }
      });
    }
  }

  onChangeQtdCartaoSelected(index) {
    this.qtdCartoes = this.cartoes.filter((cartao, i) => i <= index);
    this.atualizaValor(this.qtdCartoes.length);
  }

  atualizaValor(qtd) {
    this.qtdCartoes = this.qtdCartoes.map(cartao => {
      qtd > 1 ? cartao.valor = (this.valorTotal / qtd) : (cartao.valor = this.valorTotal);
      return cartao;
    });
  }

  gerarParcelas(numero) {
    this.matrixParcelas = [];
    for (let i = 0; i < numero; i++) {
      this.matrixParcelas.push(i + 1);
    }
    return this.matrixParcelas;
  }


  handleCaptcha($event) {
    this.captchaStatus = typeof $event === 'string' && $event.length > 10;
  }


  validaCartao(cartao) {
    if (this.validarCartaoTimeout !== null) {
      clearTimeout(this.validarCartaoTimeout);
    }

    this.validarCartaoTimeout = setTimeout(() => {

      // limpa variaveis de controle
      cartao.bandeira = '';
      cartao.cartaoVerificado = false;

      if (!cartao.numeroCartao) {
        return;
      }

      let tempCartao = cartao.numeroCartao;
      let controle = -1;
      while (controle !== tempCartao.length) {
        controle = tempCartao.length;
        tempCartao = tempCartao.replace(/\D{1,}/, '');
      }

      if (tempCartao.length === 16) {
        cartao.cartaoVerificado = true;
      }

      // visa
      const isVisa = /^4[0-9]{6,15}$/.test(tempCartao);
      if (isVisa) {
        cartao.bandeira = 'visa';
      }

      // mastercard
      const regexMastercard = new RegExp([
        /^5[1-5][0-9]{5,14}$|^222[1-9][0-9]{3,12}$|^22[3-9][0-9]{4,13}/,
        /$|^2[3-6][0-9]{5,14}$|^27[01][0-9]{4,13}$|^2720[0-9]{3,12}$/,
      ].map(r => r.source).join(''));
      const isMastercard = regexMastercard.test(tempCartao);

      if (isMastercard) {
        cartao.bandeira = 'master';
      }

      // elo - Adicionado e, 21/07/2020

      const isEloCard = /^(?:40117[8-9]|431274|438935|451416|457393|45763[1-2]|504175|627780|636297|636368|65500[0-1]|65165[2-4]|65048[5-8]|65167[5-8]|506699|5067[0-6]\d|50677[0-8]|509\d{3})\d{10}$/.test(tempCartao);
      if (isEloCard) {
        console.log('elo');
        cartao.bandeira = 'elo';
      }

    }, 200);
  }


  seValorTotalConfere() {
    return this.valorTotal === this.qtdCartoes.reduce((acc, cartao) => (acc + cartao.valor), 0);
  }

  seCartoesValidos() {
    if (this.qtdCartoes && this.qtdCartoes.length) {
      for (let i = 0; i < this.qtdCartoes.length; i++) {
        const cartao = this.cartoes[i];
        const cartaoMes = Number(cartao.mesVencimento);

        const logicasValidacao = [
          cartao.nomeCartao.length > 10, // nome do
          cartao.cartaoVerificado, // cartao valido
          Number(cartao.numeroParcelas) > 0, // numero de parcelas
          cartaoMes >= 1 && cartaoMes <= 12, // mês válido
          Number(cartao.anoVencimento) > 2000, // ano válido
          Number(cartao.valor) > 0, // valor válido
          cartao.bandeira.length, // tem bandeira
          /^[0-9]{3,4}$/.test(cartao.cvv), // cvv valido
        ];

        if (logicasValidacao.filter(val => !val).length) {
          return false;
        }
      }

      if (this.env.envName === 'test') {
        return this.seValorTotalConfere();
      } else {
        return this.seValorTotalConfere() && this.captchaStatus;
      }
    }
  }

  efetuarPagamento() {
    let configuracao = this.config[0];
    //console.log(configuracao);
    if (this.configuracaoSelecionada.hasOwnProperty('codigo') && this.configuracaoSelecionada.codigo) {
      configuracao = this.configuracaoSelecionada;
    }

    this.aoSucesso.emit({
      cartoes: this.qtdCartoes,
      configuracao,
    });
  }
}
